export const MASTER_DATA_SECTIONS = [
  "organization",
  "brands",
  "users-access",
  "distributor-inboxes",
  "purchasers",
  "purchaser-distribution-centers",
  "products",
  "product-uom",
  "product-categories",
  "product-prices",
  "retailers",
  "retailer-match-rules",
  "gl-codes",
  "gl-mapping-rules",
  "reason-code",
  "types-subtypes",
  "deduction-categories",
] as const;

export type MasterDataSection = (typeof MASTER_DATA_SECTIONS)[number];

export interface MasterDataNavItem {
  key: string;
  label: string;
  section: MasterDataSection;
}

export interface MasterDataNavCategory {
  key: string;
  label: string;
  items: MasterDataNavItem[];
}

export const MASTER_DATA_NAV_CATEGORIES: MasterDataNavCategory[] = [
  {
    key: "trading-partners",
    label: "Trading Partners",
    items: [{ key: "purchasers", label: "Purchasers", section: "purchasers" }],
  },
  {
    key: "product-catalog",
    label: "Product Catalog",
    items: [
      {
        key: "product-categories",
        label: "Product Categories",
        section: "product-categories",
      },
      { key: "products", label: "Products", section: "products" },
      { key: "product-uom", label: "Product UOM", section: "product-uom" },
    ],
  },
  {
    key: "retailers",
    label: "Retailers",
    items: [{ key: "retailers", label: "Retailers", section: "retailers" }],
  },
  {
    key: "deduction-setup",
    label: "Deduction Setup",
    items: [
      {
        key: "deduction-categories",
        label: "Categories",
        section: "deduction-categories",
      },
      {
        key: "types-subtypes",
        label: "Types & Sub-Types",
        section: "types-subtypes",
      },
      {
        key: "reason-code",
        label: "Reason Code",
        section: "reason-code",
      },
    ],
  },
  {
    key: "gl-accounting",
    label: "GL & Accounting",
    items: [
      { key: "gl-codes", label: "GL Codes", section: "gl-codes" },
      {
        key: "gl-mapping-rules",
        label: "GL Mapping Rules",
        section: "gl-mapping-rules",
      },
    ],
  },
];

export function isMasterDataSection(
  value: string | undefined,
): value is MasterDataSection {
  return (
    typeof value === "string" &&
    (MASTER_DATA_SECTIONS as readonly string[]).includes(value)
  );
}

export function getMasterDataSectionLabel(section: string): string | null {
  for (const category of MASTER_DATA_NAV_CATEGORIES) {
    const item = category.items.find((navItem) => navItem.section === section);
    if (item) {
      return item.label;
    }
  }
  return null;
}
